<template>
  <div
    class="
      doorder_reset_password doorder-auth-container doorder-auth-bg-container
    "
  >
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div class="col-xl-4 col-lg-6 col-md-9 col-sm-12 mx-auto my-auto">
          <ResetPassword
            titleH2=""
            welcomeHeader="Reset your password"
            welcomeSubheader="Enter your new password to log in to your account now."
            logoSrc="doorder/Logo.png"
            guard="DOORDER"
            clientLink="doorder"
            :token="$route.query.token"
            :email="$route.query.email"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPassword from "@/components/auth/ResetPassword.vue";

export default {
  name: "DoorderaResetPassword",
  components: { ResetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit reset password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/doorder-styles.css";
@import "../css/doorder-auth-styles.css";
</style>




// WEBPACK FOOTER //
// src/components/doorder/auth/ResetPasswordView.vue